<template>
  <el-upload
    class="video-upload"
    :action="action"
    accept="video/mp4"
    :show-file-list="false"
    :on-success="handleSuccess"
    :before-upload="beforeUpload"
    :on-progress="onProgress"
    :on-error="onError"
    :headers="headers"
    name="vedio.mp4"
  >
  </el-upload>
</template>

<script>

export default {
  name: 'UploadVideo',
  data() {
    return {
      headers: {
        token: this.$getToken(),
      },
      action: this.$baseUrl + '/api/file/update.do',
      imageUrl: this.value,
      loading:null
    }
  },
  methods: {
    // 上传之前，可以做一些校验
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message.error('上传视频大小不能超过 500MB!')
      }else{
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      return isLt2M
    },

    // 上传中
    onProgress() {
      this.$emit('onProgress')
    },

    // 上传成功后的回调
    handleSuccess(res, file) {
      this.loading.close();
      this.imageUrl = URL.createObjectURL(file.raw);
      if(res.code == 0){
        this.$emit('onSuccess', this.$baseUrl+res.data.url)
      }else{
        this.$message.error(res.msg)
      }
    },

    // 上传失败后的回调
    onError() {
      this.loading.close();
      this.$emit('onError')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UploadVideo/index.vue